export const domainError = (code, message, details) => (details === undefined ? { code, message } : { code, message, details });
//# sourceMappingURL=errors.js.map